import React, { useState } from 'react';

import { Link } from '@remix-run/react';
import Login from '~/routes/_index/login';
import Registration from '~/routes/_index/registration';
import { validateUser } from '~/services/api/auth';

export interface FooterProps {
  user: NonNullable<Awaited<ReturnType<typeof validateUser>>['user']>;
}

export default function Footer({ user }: FooterProps) {
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [openLoginSellerDialog, setOpenLoginSellerDialog] = useState(false);
  const [openRegisterDialog, setOpenRegisterDialog] = useState(false);

  const isLoggedIn = Boolean(user);
  return (
    <footer className="mt-auto border-t bg-gray-50 pt-12 text-black">
      <div className="container mx-auto flex flex-col justify-between gap-12 md:flex-row md:gap-0">
        {/* Company Info */}
        <div className="flex w-full flex-1 flex-col gap-4 px-4 md:px-0 lg:min-w-[600px]">
          <Link className="mb-2 flex flex-row items-center" to={'/'}>
            <img src="/images/best2bid-logo.svg" className="w-8 md:w-12" alt="Best2Bid Logo" />
          </Link>
          <div>
            <p className="mb-2 text-lg md:text-xl">How Can We Help You? Contact Us NOW!</p>
            <p className="mb-1 text-xs md:text-sm">Best2bid Technology Sdn Bhd</p>
            <p className="mb-1 text-xs md:text-sm">Co. Reg. No. 201701028455 (1242621-P)</p>
            <p className="mb-1 text-xs md:text-sm">(Incorporated in Malaysia)</p>
            <p className="mb-1 text-xs md:text-sm">
              Email:{' '}
              <a href="mailto:admin@best2bid.com" className="underline">
                admin@best2bid.com
              </a>
            </p>
          </div>
        </div>
        {/* Categories */}
        <div className="min-w-[150px] flex-1 px-4 md:px-0">
          <div className="text-md mb-4 text-gray-500">CATEGORIES</div>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/products?category=Art" className="hover:underline">
                Art
              </Link>
            </li>
            <li>
              <Link to="/products?category=Antiques" className="hover:underline">
                Antiques
              </Link>
            </li>
            <li>
              <Link to="/products?category=Jewellery" className="hover:underline">
                Jewellery
              </Link>
            </li>
            <li>
              <Link to="/products?category=Collectibles" className="hover:underline">
                Collectibles
              </Link>
            </li>
            <li>
              <Link to="/products?category=Coins" className="hover:underline">
                Coins
              </Link>
            </li>
            <li>
              <Link to="/products?category=Property" className="hover:underline">
                Property
              </Link>
            </li>
          </ul>
        </div>
        {/* Explore */}
        <div className="min-w-[150px] flex-1 px-4 md:px-0">
          <div className="text-md mb-4 text-gray-500">EXPLORE</div>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/auctions" className="hover:underline">
                Auctions
              </Link>
            </li>
            <li>
              <Link to="/products" className="hover:underline">
                All Products
              </Link>
            </li>
            <li>
              <Link to="/categories" className="hover:underline">
                All Categories
              </Link>
            </li>
          </ul>
        </div>
        {/* Account */}
        {!isLoggedIn ? (
          <>
            <div className="min-w-[150px] flex-1 px-4 md:px-0">
              <div className="text-md mb-4 text-gray-500">ACCOUNT</div>
              <ul className="space-y-1 text-sm">
                <li>
                  <Login
                    asSeller
                    openLoginSellerDialog={openLoginSellerDialog}
                    setOpenLoginSellerDialog={(value) => setOpenLoginSellerDialog(value)}
                    layout="footer"
                  />
                </li>
                <li>
                  <Login
                    openLoginDialog={openLoginDialog}
                    setOpenLoginDialog={(value) => setOpenLoginDialog(value)}
                    onSwitchToRegister={() => {
                      setOpenLoginDialog(false);
                      setOpenRegisterDialog(true);
                    }}
                    layout="footer"
                  />
                </li>
                <li>
                  <Registration
                    openRegisterDialog={openRegisterDialog}
                    setOpenRegisterDialog={(value) => setOpenRegisterDialog(value)}
                    onSwitchToLogin={() => {
                      setOpenRegisterDialog(false);
                      setOpenLoginDialog(true);
                    }}
                    layout="footer"
                  />
                </li>
              </ul>
            </div>
          </>
        ) : (
          <div className="min-w-[150px] flex-1 px-4 md:px-0">
            <div className="text-md mb-4 text-gray-500">ACCOUNT</div>
            <ul className="space-y-1 text-sm">
              <li>
                <form method="post" action="/api/logout">
                  <button className="cursor-pointer p-0 text-black hover:underline">
                    <p>Logout</p>
                  </button>
                </form>
              </li>
            </ul>
          </div>
        )}
      </div>
      {/* Bottom Bar */}
      <div className="mt-12 w-full border-t" />
      <div className="container mx-auto my-4 mb-12 flex flex-col items-center justify-start gap-6 pt-4 text-sm text-gray-500 md:flex-row">
        <Link to="/privacy-policy" className="hover:underline">
          Privacy Policy
        </Link>
        <Link to="/terms-of-use" className="hover:underline">
          Terms of Use
        </Link>
        <Link to="/fulfilment-policy" className="hover:underline">
          Fulfilment Policy
        </Link>
      </div>
    </footer>
  );
}
